import { Component } from '@angular/core';

@Component({
    selector: 'app-lore',
    templateUrl: './lore.component.html',
    styleUrl: './lore.component.css'
})
export class LoreComponent {

}
